/** Search param on /app/local-library that opens in-place album detail. */
export const LOCAL_ALBUM_SEARCH_PARAM = 'album';

export function encodeLocalAlbumKey(raw: string): string {
  return btoa(unescape(encodeURIComponent(raw)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function decodeLocalAlbumKey(b64: string): string {
  try {
    const padded = b64.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(escape(atob(padded)));
  } catch {
    return b64;
  }
}

export function isLocalLibraryAlbumOpen(pathname: string, search: string): boolean {
  if (!pathname.startsWith('/app/local-library')) return false;
  return !!new URLSearchParams(search).get(LOCAL_ALBUM_SEARCH_PARAM);
}

export function buildLocalLibraryAlbumUrl(albumKeyB64: string, extraParams?: Record<string, string>): string {
  const qs = new URLSearchParams(extraParams || {});
  if (!qs.get('tab')) qs.set('tab', 'albums');
  qs.set(LOCAL_ALBUM_SEARCH_PARAM, albumKeyB64);
  return `/app/local-library?${qs.toString()}`;
}
